import { EVENT_STATUS } from "../../constants/event";
import { isStartTimeUpcoming } from "./time";
import LiveContentStore from "../../../services/LiveContentStore";

export function getActiveLiveContent() {
    return LiveContentStore.get();
}

// Returns the ordered list of device-subscribed events the screen will play next:
//   - LIVE/COMING events: always included (already on-air or imminent).
//   - SCHEDULED events: only those starting before midnight in the device timezone.
//   - The currently active live content is excluded.
//   - Sorted by schedule_start ascending; LIVE/COMING before SCHEDULED.
export function getPlayingNextEvents(events, activeLiveContent) {
    const isLiveOrComing = (e) => e.status === EVENT_STATUS.LIVE || e.status === EVENT_STATUS.COMING;

    return events
        .filter((event) => {
            if (!event.isDeviceSubscribed) return false;
            if (activeLiveContent && event.id === activeLiveContent.id) return false;
            if (isLiveOrComing(event)) return true;
            if (event.status === EVENT_STATUS.SCHEDULED) return event.schedule_start && isStartTimeUpcoming(event.schedule_start);
            return false;
        })
        .sort((a, b) => {
            const aLive = isLiveOrComing(a);
            const bLive = isLiveOrComing(b);
            if (aLive && !bLive) return -1;
            if (!aLive && bLive) return 1;
            const startA = a.schedule_start ? new Date(a.schedule_start).getTime() : 0;
            const startB = b.schedule_start ? new Date(b.schedule_start).getTime() : 0;
            return startA - startB;
        })
        .slice(0, 3);
}

// Splits events into three (intentionally overlapping) buckets:
//   - live: LIVE or COMING events (actively on-air or about to start).
//   - upcoming: all SCHEDULED events (future, regardless of subscription).
//   - scheduled: subset of upcoming where the device is subscribed — shown in a separate EPG section.
export function categorizeEvents(events) {
    const live = [], upcoming = [], scheduled = [];
    events.forEach((event) => {
        if (event.status === EVENT_STATUS.LIVE || event.status === EVENT_STATUS.COMING) live.push(event);
        if (event.status === EVENT_STATUS.SCHEDULED) upcoming.push(event);
        if (event.status === EVENT_STATUS.SCHEDULED && event.isDeviceSubscribed) scheduled.push(event);
    });
    return { live, upcoming, scheduled };
}

export function hasTeams(event) {
    return !!(
        event.firstTeam?.logo && event.firstTeam?.display_name &&
        event.secondTeam?.logo && event.secondTeam?.display_name
    );
}

export function getUpcomingEventsWithTeams() {
    return (window.__UpshowState?.upcomingLiveContent ?? []).filter(hasTeams);
}
